import { Background, MiniMap, ReactFlow } from '@xyflow/react';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import Controls from '@/components/flow/components/controls';
import { FlowDelayedActions } from '@/components/flow/components/flow-delayed-actions';
import { useFlowBuilder } from '@/hooks/use-flow-builder.ts';
import useFlowStore from '@/store/flow';
import { nodeTypes } from '@/types/flow-types';
import { defaultEdgeOptions, fitViewOptions } from './flow.data';

const Flow = () => {
	const { setMentionOptions, setTypesOptions, setItemsDictionary } =
		useFlowStore(
			useShallow((state) => ({
				setMentionOptions: state.setMentionOptions,
				setTypesOptions: state.setTypesOptions,
				setItemsDictionary: state.setItemsDictionary
			}))
		);

	const { nodes, mentionOptions, typesOptions, itemsDictionary } =
		useFlowBuilder();

	useEffect(() => {
		setMentionOptions(mentionOptions);
		setTypesOptions(typesOptions);
		setItemsDictionary(itemsDictionary);
	}, [
		mentionOptions,
		typesOptions,
		setMentionOptions,
		setTypesOptions,
		itemsDictionary,
		setItemsDictionary
	]);

	return (
		<ReactFlow
			defaultEdgeOptions={defaultEdgeOptions}
			fitView
			fitViewOptions={fitViewOptions}
			maxZoom={4}
			minZoom={0.1}
			nodes={nodes}
			nodesConnectable={false}
			nodesDraggable={false}
			nodeTypes={nodeTypes}
			panOnScroll
			zoomOnScroll={false}
		>
			<Background />
			<Controls />
			<MiniMap
				nodeColor={(n) => `color-mix(in srgb, ${n.data.color} 15%, white)`}
			/>
			<FlowDelayedActions />
		</ReactFlow>
	);
};

export default Flow;
